import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.1.5@rc-checkbox/es/index.js
// module id = 224
// module chunks = 1